import { AxiosError } from 'axios'

export abstract class ExpectedError extends Error {}

/**
 * Type guard to check if an error is an ExpectedError
 */
export function isExpectedError(error: any): error is ExpectedError {
  return error instanceof ExpectedError
}
export class RestaurantNotFoundError extends ExpectedError {
  constructor(restaurantId: string | undefined, cause?: Error) {
    super(`Restaurant with ID ${restaurantId} not found or access forbidden`, cause ? { cause } : undefined)
  }
}

export class InvalidRestaurantIdError extends ExpectedError {
  constructor(restaurantId: string | undefined, cause?: Error) {
    super(`Invalid restaurant ID: ${restaurantId}`, cause ? { cause } : undefined)
  }
}

export function isInvalidRestaurantIdError(error: Error): error is InvalidRestaurantIdError {
  return error instanceof InvalidRestaurantIdError
}

export function createExpectedRestaurantErrorFromError(
  originalError: Error | AxiosError,
  rid: string | undefined
): ExpectedError | Error {
  if (!('response' in originalError)) {
    return originalError
  }
  switch (originalError.response?.status) {
    case 403:
    case 404:
      return new RestaurantNotFoundError(rid, originalError)
    case 400:
      return new InvalidRestaurantIdError(rid, originalError)
    default:
      return originalError
  }
}

export class OfferNotAvailableForCombinationError extends ExpectedError {
  constructor(cause?: Error) {
    super('The selected offer is not available for the chosen combination', cause ? { cause } : undefined)
  }
}

export function isOfferNotAvailableForCombinationError(error: Error): error is OfferNotAvailableForCombinationError {
  return error instanceof OfferNotAvailableForCombinationError
}
